<template>

  <div class="play-list">
    <div class="level" style="margin-bottom: 1rem;">
      <div class="level-left">
        <div class="level-item">
          <strong>Plays</strong>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button
            class="button is-small is-link is-outlined"
            @click="showCreateForm = !showCreateForm"
          >
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span>Play</span>
          </button>
        </div>
      </div>
    </div>

    <play-form
      v-if="showCreateForm"
      :errors="errors"
      :saving="saving"
      @save="handleCreate"
      @cancel="showCreateForm = false"
    />

    <div v-if="!sortedPlays.length && !showCreateForm" class="notification is-light">
      No plays in this bucket.
    </div>

    <div
      v-for="play in sortedPlays"
      :key="play.id"
      class="play-item"
    >
      <div class="level" style="margin-bottom: 0;">
        <div class="level-left">
          <div class="level-item">
            <a @click="toggleExpand(play.id)" style="font-weight: 500;">
              <span class="icon is-small">
                <i :class="expandedPlayId === play.id ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
              </span>
              {{ play.label }}
            </a>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <button
              class="button is-small is-outlined"
              @click="toggleExpand(play.id)"
            >
              <span class="icon"><i class="fas fa-pencil-alt"></i></span>
            </button>
          </div>
          <div class="level-item">
            <button
              class="button is-small is-danger is-outlined"
              @click="handleDelete(play)"
            >
              <span class="icon"><i class="fas fa-trash"></i></span>
            </button>
          </div>
        </div>
      </div>

      <play-form
        v-if="expandedPlayId === play.id"
        :play="play"
        :errors="errors"
        :saving="saving"
        @save="handleUpdate(play, $event)"
        @cancel="expandedPlayId = null"
      />
    </div>
  </div>

</template>
<script>

  import PlayForm from './PlayForm.vue';

  export default {

    components: {
      PlayForm,
    },

    props: {
      plays: {
        type: Array,
        required: true,
      },
      playbookId: {
        type: Number,
        required: true,
      },
      bucketId: {
        type: Number,
        required: true,
      },
      errors: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      saving: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data () {
      return {
        expandedPlayId: null,
        showCreateForm: false,
      };
    },

    computed: {

      sortedPlays () {
        return [...this.plays].sort((a, b) => a.sort_order - b.sort_order);
      },

    },

    methods: {

      toggleExpand (playId) {
        this.expandedPlayId = this.expandedPlayId === playId ? null : playId;
      },

      handleCreate (form) {
        this.$emit('create-play', {
          playbookId: this.playbookId,
          bucketId: this.bucketId,
          ...form,
        });
        this.showCreateForm = false;
      },

      handleUpdate (play, form) {
        this.$emit('update-play', {
          playbookId: this.playbookId,
          bucketId: this.bucketId,
          playId: play.id,
          ...form,
        });
        this.expandedPlayId = null;
      },

      handleDelete (play) {
        if (!confirm(`Delete play "${play.label}"? This cannot be undone.`)) {
          return;
        }
        this.$emit('delete-play', {
          playbookId: this.playbookId,
          bucketId: this.bucketId,
          playId: play.id,
        });
      },

    },
  };

</script>

<style lang="scss" scoped>
  .play-item {
    padding: 0.5rem 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }
  }
</style>
